import styles from './index.css'
import * as preact from 'preact'

const { h, Component } = preact

export const Byline = () => {
  return (
    <div className={styles.bylinewrapper}>
      <span className={styles.bylinetext}>
        Foto: <i>Christian Nicolai Bjørke</i>
        <br />
        Illustrasjon: <i>Marco Vaglieri</i>
        <br /> Digital historieutvikling:{' '}
        <i>
          Susanne Stubberud Rom, Annichen Woll Eide,{' '}
          <span className={styles.nowrap}>Sjur Seibt</span>, Ragnar Aasen Rognstad
        </i>
      </span>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/v1/components/Footer/Byline/index.tsx